import React, { useState, useEffect } from "react";
import Footer from "components/Footers/Footer";
import Navbar from "components/Navbars/AuthNavbar";
import BASE_URL from "components/BaseUrl/apiConfig";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import BlockUiOverlay from "components/Expense/BlockUiOverlay";

const GetAllItems = () => {
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  //get userid form loca storage
  const storedUserData = localStorage.getItem("userData");
  let userId = "";
  let userTypeId = "";
  let groupId = "";
  if (storedUserData) {
    const userData = JSON.parse(storedUserData);
    userId = userData.userId;
    userTypeId = userData.userTypeId;
    groupId = userData.groupId;
  }

  const [items, setIthems] = useState([]);
  const [currency, setCurrency] = useState("");

  //function of getAllItems
  const fetchItems = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `${BASE_URL}/api/Item/GetAllItems?UserId=${userId}`
      );
      const data = await response.json();
      setIthems(data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    const fetchCurrencyData = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/api/Users/GetCurrencyByUserId?groupId=${groupId}`
        );
        const data = await response.json();
        // Assuming the API response has a property called 'currency'
        setCurrency(data.currency);
      } catch (error) {
        console.error("Error fetching currency data:", error);
      } finally {
      }
    };

    fetchCurrencyData();
  }, []);

  //Call function on any change on this page
  useEffect(() => {
    fetchItems();
  }, []); // Fetch items when component mounts

  // Function to navigate to the "addItem" page
  const NavigateAddItemPage = () => {
    history.push("/addItem");
  };

  //function to navigate the "getQuantityTraking" page

  const NavigateQuantityPage = () => {
    history.push("/getQuantityTraking");
  };

  // Function to navigate to the "itemDetails" page
  const NavigateDetailsItemPage = (item) => {
    history.push({
      pathname: `/itemDetails`,
      state: { item },
    });
  };

  const NavigateEditItem = (item) => {
    history.push({
      pathname: "/addItem",
      state: { item: item }, // Pass the item data as state
    });
  };

  //here is the code of the Delete Item
  const deleteItem = (itemID, itemName) => {
    // Show a SweetAlert confirmation before deleting
    Swal.fire({
      title: "Confirmation",
      text: `Are you sure want to delete ${itemName}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        // User clicked "Yes, delete it!" - Perform the delete API call
        fetch(`${BASE_URL}/api/Item/DeleteItem?itemId=${itemID}`, {
          method: "Post",
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.success) {
              // Handle successful delete (remove the user from the state, show success message, etc.)
              setIthems((prevUsers) =>
                prevUsers.filter((item) => item.itemID !== itemID)
              );
              Swal.fire(
                "Deleted!",
                "Item has been deleted successfully.",
                "success"
              );
            } else {
              // Handle delete failure (show error message, etc.)
              Swal.fire("Error!", "Item deletion failed.", "error");
            }
          })
          .catch((error) => console.error("Error deleting item:", error));
      }
    });
  };

  return (
    <>
      <Navbar />
      <div className="cust-div" style={{ minHeight: "550px" }}>
        <BlockUiOverlay visible={loading} />
        <div className="container mx-auto p-4">
          <div className="flex justify-between items-center mb-4 flex-wrap">
            <h1 className="text-2xl  font-bold">Items Management</h1>
            <div>
              {userTypeId === 2 && (
                <>
                  {/* <button
                    onClick={NavigateQuantityPage}
                    className="bg-lightBlue-500 text-white active:bg-lightBlue-600 mr-3 text-xs font-bold uppercase px-4 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
                    type="button"
                  >
                    Go to Quantity Tracking
                  </button> */}
                  <button
                    onClick={NavigateQuantityPage}
                    className="bg-lightBlue-500 text-white active:bg-lightBlue-600 mr-3 text-xs font-bold uppercase px-4 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
                    type="button"
                  >
                    <i
                      className="fa fa-arrow-circle-left mr-1"
                      title="Go to Quantity Tracking"
                    ></i>
                  </button>

                  <button
                    onClick={NavigateAddItemPage}
                    className="bg-lightBlue-500 text-white active:bg-lightBlue-600 text-xs font-bold uppercase px-4 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
                    type="button"
                  >
                    Add new Item
                  </button>
                </>
              )}
            </div>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full min-w-full">
              <thead>
                <tr className="border-b bg-lightBlue-500 text-white ">
                  <th className="cell py-2 px-4 font-bold text-left">Name</th>
                  <th className="cell py-2 px-4 font-bold text-left">
                    Cost({currency})
                  </th>
                  <th className="cell py-2 px-4 font-bold text-left">
                    Description
                  </th>
                  <th className="cell py-2 px-4 font-bold text-left">
                    Default Text
                  </th>
                  <th className="cell py-2 px-4 font-bold text-left">Order</th>
                  <th className="cell py-2 px-4 font-bold text-left">Color</th>
                  {userTypeId === 2 && (
                    <th
                      className="cell py-2 px-4 font-bold "
                      style={{ float: "inline-end" }}
                    >
                      Actions
                    </th>
                  )}
                </tr>
              </thead>
              <tbody>
                {items && items.length > 0 ? (
                  items.map((item) => (
                    <tr
                      key={item.itemID}
                      className="hover:bg-gray-100 border-b"
                    >
                      <td className="cell py-1 px-4 text-left">
                        {item.itemName}
                      </td>
                      <td className="cell py-1 px-4 text-left">
                        {item.itemCost}
                      </td>
                      <td className="cell py-1 px-4 text-left">
                        {item.itemDescription}
                      </td>
                      <td className="cell py-1 px-4 text-left">
                        {item.defaultText}
                      </td>
                      <td className="cell py-1 px-4 text-left">
                        {item.tabOrder}
                      </td>
                      <td className="cell py-1 px-4 text-left">
                        <div
                          style={{
                            background: item.color,
                            height: "20px",
                            padding: "0px",
                          }}
                        ></div>
                      </td>
                      {userTypeId === 2 && (
                        <td className="cell py-2 px-4 flex justify-end">
                          {/* Edit Icon */}
                          <img
                            src={require("assets/img/Editicon.png")}
                            alt="Edit"
                            title="Edit"
                            className="mr-2 cursor-pointer"
                            style={{ width: "20px" }}
                            onClick={() => NavigateEditItem(item)}
                          />

                          {/* View Icon */}
                          <img
                            src={require("assets/img/Viewicon.png")}
                            title="View"
                            alt="View"
                            className="mr-2 cursor-pointer"
                            style={{ width: "20px" }}
                            onClick={() => NavigateDetailsItemPage(item)}
                          />

                          {/* Delete Icon */}
                          <img
                            src={require("assets/img/deleteicon.png")}
                            title="Delete"
                            alt="Delete"
                            className="cursor-pointer"
                            style={{ width: "20px" }}
                            onClick={() =>
                              deleteItem(item.itemID, item.itemName)
                            }
                          />
                        </td>
                      )}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="7"
                      className="text-center text-lg text-gray-900 mt-4"
                    >
                      No data found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default GetAllItems;
